import { createSlice } from '@reduxjs/toolkit';

import { RootState } from './Store';

const initialState = {
  isLoggedIn: !!localStorage.getItem("isLoggedIn"),
  username: localStorage.getItem("username"),
  organization: localStorage.getItem("organization"),
  userId: localStorage.getItem("userId"),
};

const uapiUserSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      const username = action.payload.username;
      //HACK: TEMPORARY WHILE IMPLEMENTING PROPERT CLAIMS
      const org = "rewire"; // username.substring(username.indexOf("@") + 1);
      const userId = action.payload.userId;
      state.organization = org;
      state.username = username;
      state.userId = userId;
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("username", username);
      localStorage.setItem("organization", org);
      localStorage.setItem("userId", userId);
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.username = null;
      state.organization = null;
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("username");
      localStorage.removeItem("organization");
      localStorage.removeItem("userId");
    },
  },
});

export const { login, logout } = uapiUserSlice.actions;
export const userDataSelector = (state: RootState) => state.User;
export default uapiUserSlice.reducer;
